import { WarningIcon } from '@p2p/assets/svg';
import { Button, Modal, Typography } from '@p2p/components';
import { TGetOrderResponse } from '@p2p/services';
import { useState } from 'react';

import styles from './SberQrInvoiceWarningModal.module.scss';

type SberQrInvoiceWarningModalProps = {
  order: TGetOrderResponse;
};

// P2P-2602: если оплата идёт через QR Invoice и клиенту выдан реквизит Сбербанка,
// предупреждаем, что перевод нужно совершать только с него — иначе средства будут утеряны.
const shouldShowWarning = (order: TGetOrderResponse) =>
  order.client_bank_code === 'sber' && order.requisite.qr_invoice === true;

export const SberQrInvoiceWarningModal = ({ order }: SberQrInvoiceWarningModalProps) => {
  const [isOpen, setIsOpen] = useState(true);

  if (!shouldShowWarning(order)) {
    return null;
  }

  return (
    <Modal open={isOpen} onClose={() => setIsOpen(false)}>
      <div className={styles.container}>
        <WarningIcon className={styles.icon} />
        <Typography variant="h2" color="heading" className={styles.title}>
          Внимание
        </Typography>
        <Typography variant="text-m-medium" color="description" className={styles.text}>
          Перевод по QR-коду должен быть совершён только со{' '}
          <span className={styles.accent}>Сбербанка</span>. Если оплата будет произведена с другого
          банка, средства могут быть утеряны.
        </Typography>
      </div>
      <Button fullWidth onClick={() => setIsOpen(false)}>
        Осуществить оплату
      </Button>
    </Modal>
  );
};
